import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SearchBarContainer } from "../shared-components/searchInput/search-input-styles";
import { SearchInput } from "../shared-components/searchInput/SearchInput";
import MembersContext from "../../../application/Context/MembersContext";
export var SearchBar = function () {
    var _a = useContext(MembersContext), handleSearchInput = _a.handleSearchInput, searchCompanies = _a.searchCompanies, handleKeyDown = _a.handleKeyDown;
    var t = useTranslation(["common"]).t;
    return (_jsx(React.Fragment, { children: _jsxs(SearchBarContainer, { children: [_jsx("label", { htmlFor: "searchinput", style: { display: "none" }, children: t("Search") }), _jsx(SearchInput, { placeholder: t("Search"), id: "searchinput", type: "text", onChange: handleSearchInput, handleSearch: searchCompanies, onKeyDown: handleKeyDown })] }) }));
};
